import React, { useState } from "react";
import PopupModal from "../../../UI/Popup";
import { TJobData } from "../../../../store/candidate/types";
import {
  getJobCentreNameByVacancy,
  getJobTitleNameForCandidate,
  withDrawOrDeclineJob,
} from "../../../../services/candidateJobsService";
import { formatTimeframes } from "../../../Vacancy/timeframeApiHelper";
import { useFormik } from "formik";
import { createValidationSchema } from "../../../../utils/createValidationSchema";
import CustomButton from "../../../UI/Buttons/CustomButton";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../../../../store";
import { isFulfilled } from "@reduxjs/toolkit";
import CharacterLimitTextarea from "../../../UI/Inputs/CharacterLimitTextarea";
import Warning from "../../../UI/Icons/Warning";
import { getCandidateCalendarData } from "../../../../store/candidate/thunks";

interface WithdrawApplyJobModalProps {
  showApplyJobModal: boolean;
  setShowApplyJobModal: React.Dispatch<React.SetStateAction<boolean>>;
  onClickClose?: () => void;
  vacancyData: TJobData;
  handleApplyForJob: (vacancyData: TJobData) => void;
  getCandidateJobList?: () => void;
  setShowViewModal?: (show: boolean) => void;
  showSingleDayView?: (show: boolean) => void;
  onRefresh?: () => void;
}

const WithdrawApplyJobModal: React.FC<WithdrawApplyJobModalProps> = ({
  showApplyJobModal,
  handleApplyForJob,
  onClickClose,
  setShowApplyJobModal,
  vacancyData,
  getCandidateJobList,
  setShowViewModal,
  showSingleDayView,
  onRefresh
}) => {
  const dispatch = useDispatch();

  const profileData = useSelector(
    (state) => state.onboarding.userpersonaldetails
  );
  const maxDistanceAway = useSelector((state) => state.candidateJobs.maxDistanceAwayForMyCalendar)
  

  const [showWithdrawDonePopup, setShowWithdrawDonePopup] = useState(false);

  const handleClose = () => {
    setShowApplyJobModal(false);
    resetForm && resetForm();
    if (onClickClose) {
      onClickClose();
    }
  };

  const handleWithdrawDoneClose = async () => {
    setShowWithdrawDonePopup(false)
    await dispatch(getCandidateCalendarData({ distance_away: maxDistanceAway}));
    await getCandidateJobList?.(); 
    resetForm && resetForm();
  }

  const { handleSubmit, values, errors, setFieldValue, resetForm } =
    useFormik<any>({
      validationSchema: createValidationSchema("withdraw_job_application"),
      initialValues: {
        comments: "",
      },
      onSubmit: async (values: any) => {
        const data = {
          uuid: vacancyData?.uuid,
          candidate_uuid: profileData?.uuid ?? "",
          action: "withdraw",
          comments: values.comments || "",
        };
        const applyJobResponse = await withDrawOrDeclineJob(dispatch, data);
        if (isFulfilled(applyJobResponse)) {
          setShowApplyJobModal(false);
          setShowViewModal && setShowViewModal(false); // Hide centre view modal
          showSingleDayView && showSingleDayView(false); // Hide single day view
          
          setShowWithdrawDonePopup(true)
        }
      },
    });

  const handleChange = (data: string) => {
    setFieldValue("comments", data);
  };
 
  return (
    <>
      <PopupModal
        visible={showWithdrawDonePopup}
        showCloseBtn={true}
        onClickClose={handleWithdrawDoneClose}
        customWidth={650}
      >
        <div className="gap-20 fs-22">
          You have withdrawn your application
        </div>
        <div className="gap-20 fs-13">
          {getJobTitleNameForCandidate(vacancyData)} {" "}
          at {getJobCentreNameByVacancy(vacancyData)},{" "}
          {vacancyData?.centre?.address} on {" "}
          {vacancyData?.timeframes &&
            formatTimeframes(vacancyData?.timeframes)?.map(
              (formatedTimeData, index) => (
                <div
                  key={index}
                  className={`fs-13 d-inline ${
                    formatedTimeData.alert ? "text-alert fw-700" : "fw-400"
                  }`}
                >
                  {formatedTimeData.label}
                </div>
              )
            )}
        </div>
        <div className="gap-20 fs-13">
          You will not see this job listing now.
        </div>
      </PopupModal>

      <PopupModal
        visible={showApplyJobModal}
        showCloseBtn={true}
        onClickClose={handleClose}
        customWidth={650}
      >
        <div className="gap-20 fs-22">
          Are you sure you want to withdraw your application?
        </div>
        <div className="bg-teal-light px-15px py-10px radius-8px d-flex gap-6">
          <Warning />
          Withdrawing applications or declining accepted jobs are noted on your
          record. A consultant may be in contact with you if you withdraw or
          decline too many times. You will not see this job listing after you
          withdraw.
        </div>
        <div className="d-flex flex-column gap-8">
          <div className="fs-13">
            You are about to withdraw your application for the following job:{" "}
            {getJobTitleNameForCandidate(vacancyData)} {" "}
            at {getJobCentreNameByVacancy(vacancyData)},{" "}
            {vacancyData?.centre?.address} on {" "}
            {vacancyData?.timeframes &&
              formatTimeframes(vacancyData?.timeframes)?.map(
                (formatedTimeData, index) => (
                  <div
                    key={index}
                    className={`fs-13 d-inline ${
                      formatedTimeData.alert ? "text-alert fw-700" : "fw-400"
                    }`}
                  >
                    {formatedTimeData.label}
                  </div>
                )
              )}
          </div>
          <div className="fs-13">
            Please include a reason for your withdrawal.
          </div>
        </div>

        <CharacterLimitTextarea
          maxLength={1000}
          value={values.comments}
          onChange={(value) => handleChange(value)}
          error={
            typeof errors.comments === "string" ? errors.comments : undefined
          }
          type="withdraw"
        />

        <div className="d-flex justify-content-end">
          <CustomButton
            className="btn-theme bg-alert text-white"
            onClick={handleSubmit}
            // disabled={!values.comment || Object.keys(errors).length > 0}
            variant="primary"
            contentClass="d-flex"
          >
            Confirm and Withdraw
          </CustomButton>
        </div>

      </PopupModal>
    </>
  );
};

export default WithdrawApplyJobModal;
